module.exports = __webpack_public_path__ + "img/media_15.73a92041.jpg";